module.exports = __webpack_public_path__ + "images/bg-today-gold-value.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/bg-today-gold-value.png
// module id = 837
// module chunks = 125